var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 3c1.654 0 3 1.346 3 3v12c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3V6c0-1.654 1.346-3 3-3h12zm0 2H6c-.551 0-1 .449-1 1v1h1c.828 0 1.5.672 1.5 1.5 0 .78-.595 1.42-1.356 1.493L6 10H5v4h1c.828 0 1.5.672 1.5 1.5 0 .78-.595 1.42-1.356 1.493L6 17H5v1c0 .551.449 1 1 1h12c.551 0 1-.449 1-1V6c0-.551-.449-1-1-1zm-5 3c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 2c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z",
    transform: "translate(-1140 -423) translate(328 72) translate(785 63) translate(11 268) translate(0 8) translate(16 12)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.69e4e7674790c897cab6fa2cc10e0efe.svg";
export { ForwardRef as ReactComponent };